module.exports = __webpack_public_path__ + "img/CY120009.f8bdf797.png";